import {
  restoreTheme,
  setTheme,
  updateThemeColor,
  saveTheme,
  categories,
} from 'app/actions/theme.actions';
import template from './theme.html';
import dialogTemplate from './theme-notification.html';

const mapStateToThis = ({ theme }) => ({
  theme,
  categories,
});

const mapDispatchToThis = {
  restoreTheme,
  setTheme,
  updateThemeColor,
  saveTheme,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', 'Notifications', 'gettextCatalog')
class CmsThemeController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.showNotification();
    this.unsubscribe();
  }

  onColorChangeHandler(color) {
    this.updateThemeColor(color);
  }

  async onSaveHandler() {
    await this.saveTheme();

    if (this.theme.error) return this.Notifications.alertError(this.gettextCatalog.getString('Something went wrong. Please try again.'));

    this.Notifications.alertSuccess(this.gettextCatalog.getString('Theme has been saved.'));
    this.form.$setPristine();
  }

  onCancelHandler() {
    this.setTheme();
    this.form.$setPristine();
  }

  onRestoreHandler() {
    this.restoreTheme();
    this.form.$setDirty();
  }

  showNotification() {
    if (this.form.$dirty) this.Notifications.showSimpleDialog(dialogTemplate);
  }
}

export class CmsThemeComponent {
  constructor() {
    this.controller = CmsThemeController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/theme/theme-component.js